import React from 'react';
import { Navigate, Params } from 'react-router-dom';
import { inject, observer } from 'mobx-react'; 
import ProductStore from './ProductStore'; 
import { UtilityMethods, withRouter } from '@mindmemobile/mm-shared-global';
import { UpsertProductActiveStep } from '../../shared/enums';

interface IProps {
    productStore?: ProductStore;
    children: React.ReactElement;
    currentRoute: string;
    params: Readonly<Params<string>>;
}

const ProtectedRoute: React.FC<IProps> = ({ children, currentRoute, productStore, params }) => {
    let isValid = false;
    const productId = () => {
        const split = ((params && params['*']) || '').split('/');
        const id = split[split.length - 1];
        if (UtilityMethods.isValidObjectId(id)) {
            return id;
        }
        return null;
    };

    switch (productStore?.activeStep) {
        case UpsertProductActiveStep.Detail:
            isValid = currentRoute === 'detail';
            break;
        case UpsertProductActiveStep.Pricing:
            isValid = currentRoute === 'pricing';
            break;
        case UpsertProductActiveStep.Variants:
            isValid = currentRoute === 'variants';
            break;
        case UpsertProductActiveStep.Options:
            isValid = currentRoute === 'options';
            break;
    }

    const queryParam: string = productId() ? `/${productId()}` : '';
    return isValid ? children : <Navigate to={`/app/product/detail${queryParam}`} />;
};

export default inject('productStore')(withRouter(observer(ProtectedRoute)));
